import Flickity from 'flickity';
import { cursorNavigation } from '../base/carousel';

export function init() {
	const elements = Array.from(document.querySelectorAll('.js-hzm'));

	elements.forEach(element => create(element));
}

function create(element) {
	let scroller;
	let isOpen = false;

	const control = element.querySelector('.js-hzm-control');
	const target = document.getElementById(control.dataset.target);
	const text = control.querySelector('.js-hzm-text');
	const controlID = `${control.dataset.target}-control`;
	const items = element.querySelector('.js-hzm-items');

	target.setAttribute('aria-labelledby', controlID);

	control.setAttribute('id', controlID);
	control.setAttribute('aria-expanded', 'false');
	control.setAttribute('aria-controls', control.dataset.target);

	control.addEventListener('click', function toggle() {
		isOpen ? close() : open();
	});

	scroller = new Flickity(items, {
		cellAlign: 'left',
		contain: true,
		freeScroll: true,
		prevNextButtons: false,
	});

	cursorNavigation(scroller);

	function open() {
		isOpen = true;
		element.classList.add('is-open');
		control.setAttribute('aria-expanded', 'true');
		text.textContent = text.textContent.replace(/Show/g, 'Hide');
		scroller.resize();
	}

	function close() {
		isOpen = false;
		element.classList.remove('is-open');
		control.setAttribute('aria-expanded', 'false');
		text.textContent = text.textContent.replace(/Hide/g, 'Show');
	}
}
